
import React from "react";
import styled from "styled-components";

const tagStyles = ({ $bgColor, $textColor, $allSidesRounded }) => `
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  gap: 2px;
  padding: 4px 8px;
  background: ${$bgColor || "#f0f1f4"};
  color: ${$textColor || "#7b8498"};
  border-right: 0.75px solid ${$bgColor || "#f0f1f4"};
  border-bottom: 0.75px solid ${$bgColor || "#f0f1f4"};
  border-left: 0.75px solid ${$bgColor || "#f0f1f4"};
  border-top: ${$allSidesRounded ? `0.75px solid ${$bgColor || "#f0f1f4"}` : "none"};
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
  border-top-right-radius: ${$allSidesRounded ? "4px" : "0"};
  border-top-left-radius: ${$allSidesRounded ? "4px" : "0"};

  span {
    color: inherit;
    font-size: 12px;
    font-weight: 600;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

const CardHeaderTagRoot = styled.div`
  ${(props) => tagStyles(props)}
`;

const PageHeaderTagRoot = styled.div`
  ${(props) => tagStyles(props)}
  display: flex;
  width: 100%;

  span {
    width: 100%;
    text-align: center;
  }
`;

/**
 * CardHeaderTag – inline-flex, fits content width.
 *
 * Props:
 *   text          {string}  – label text rendered inside the tag
 *   textColor     {string}  – CSS color for text (default #7b8498)
 *   bgColor       {string}  – CSS color for background/border (default #f0f1f4)
 *   allSidesRounded {bool}  – when true all corners are 4px; otherwise only bottom corners
 */
export const CardHeaderTag = ({ text, textColor, bgColor, allSidesRounded = false, ...rest }) => (
  <CardHeaderTagRoot
    $textColor={textColor}
    $bgColor={bgColor}
    $allSidesRounded={allSidesRounded}
    {...rest}
  >
    <span>{text}</span>
  </CardHeaderTagRoot>
);

/**
 * PageHeaderTag – same as CardHeaderTag but stretches to full parent width (display: flex).
 *
 * Props:
 *   text          {string}  – label text rendered inside the tag
 *   textColor     {string}  – CSS color for text (default #7b8498)
 *   bgColor       {string}  – CSS color for background/border (default #f0f1f4)
 *   allSidesRounded {bool}  – when true all corners are 4px; otherwise only bottom corners
 */
export const PageHeaderTag = ({ text, textColor, bgColor, allSidesRounded = false, ...rest }) => (
  <PageHeaderTagRoot
    $textColor={textColor}
    $bgColor={bgColor}
    $allSidesRounded={allSidesRounded}
    {...rest}
  >
    <span>{text}</span>
  </PageHeaderTagRoot>
);
